import { render, staticRenderFns } from "./WordPress.vue?vue&type=template&id=23a008e4&"
import script from "./WordPress.vue?vue&type=script&lang=js&"
export * from "./WordPress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports